import { DefaultState, ProgramTypes } from 'features/types';
import { MemberGroupCanPostPermissions, MemberGroupCanInviteToProgramsPermissions, MemberGroupCanViewOtherMembersPermissions, MemberGroupCanPostResourcePermissions, MemberGroupCanPostResourceEventsPermissions, MemberGroupCanPostResourceProductsAndServicesPermissions } from 'features/programs/types';
import { MemberNavSettings } from 'features/organizations/types';

export type AuthState = DefaultState & {
  isAuthenticated: boolean;
  jobSeeker: JobSeeker | null;
  from: string | null;
};

export type JobSeekerAuthState = AuthState & {
  applyJobId: string | undefined;
};

export interface JobSeekerOrganization {
  id: string;
  name: string;
  logo: string;
}

export interface CurrentMemberGroupPermission {
  totalGroupsAllowedToPost: number;
  totalGroupsAllowedToInviteTo: number;
  totalGroupsAllowedToViewMembers: number;
  totalGroupsAllowedToPostResource: number;
  totalGroupsAllowedToPostResourceEvents: number;
  totalGroupsAllowedToPostResourceProductsAndServices: number;
  atLeastOneCanPostPrivacyTypeAllowsMembersToPost: boolean;
  atLeastOneCanPostPrivacyTypeAllowsEmployersToPost: boolean;
  atLeastOnEnablePromoteJobPostsToNetworks: boolean;
  atLeastOnEnablePromoteResourcePostsToNetworks: boolean;
  atLeastOnEnablePromoteResourceEventsPostsToNetworks: boolean;
  atLeastOnEnablePromoteResourceProductsAndServicesPostsToNetworks: boolean;
  groupCanPostPermission: MemberGroupCanPostPermissions,
  groupTypesCanPostPermission: ProgramTypes[]
  groupCanInviteToProgramsPermission: MemberGroupCanInviteToProgramsPermissions,
  groupTypesCanInviteToProgramsPermission: ProgramTypes[]
  groupCanViewOtherMembersPermission: MemberGroupCanViewOtherMembersPermissions,
  groupTypesCanViewOtherMembersPermission: ProgramTypes[],
  groupCanPostResourcePermission: MemberGroupCanPostResourcePermissions,
  groupTypesCanPostResourcePermission: ProgramTypes[],
  groupCanPostResourceEventsPermission: MemberGroupCanPostResourceEventsPermissions,
  groupTypesCanPostResourceEventsPermission: ProgramTypes[],
  groupCanPostResourceProductsAndServicesPermission: MemberGroupCanPostResourceProductsAndServicesPermissions,
  groupTypesCanPostResourceProductsAndServicesPermission: ProgramTypes[],
}

export enum JobSeekerCommunityAdminRole {
  FullAdmin = 'FullAdmin',
  ViewOnlyAdmin = 'ViewOnlyAdmin',
  None = 'None',
}

export type CommunityItemMemberRoles = {
  communityAdminRole: JobSeekerCommunityAdminRole;
  leadPrograms: string[];
}

export type CommunityMemberRoles = {
  [communityId: string]: CommunityItemMemberRoles;
}

export type MemberCumulativeRoles = {
  leadProgramsIds: string[];
  adminCommunityIds: string[];
  communitiesRoles: CommunityMemberRoles;
}

export type JobSeeker = {
  id: string;
  name: string;
  isPasswordSet: boolean;
  email?: string;
  photo?: string;
  groupPermissions?: CurrentMemberGroupPermission;
  verifiedOrganizationIds?: string[];
  verifiedOrganizations?: JobSeekerOrganization[];
  cumulativeRoles?: MemberCumulativeRoles;
  memberNavSettings?: MemberNavSettings;
};

export type JobSeekerSignInSocialMedia = {
  credential: string;
};

export type JobSeekerSignUpSocialMedia = {
  credential: string;
  token?: string;
  joinNowToken?: string;
};

export enum SocialType {
  Google = 'Google',
  Facebook = 'Facebook',
  Apple = 'Apple',
};
